import React from 'react'
import Header from '../Components/Header/Header'
import OurServices from '../Components/OurServices/OurServices'
import ContactUs from '../Components/ContactUs/ContactUs'
import Footer from '../Components/Footer/Footer'

const OurServicesPage = () => {
  return (
    <>
    <Header/>
    <OurServices/>
    <ContactUs/>
    <Footer/>
    
    </>
  )
}

export default OurServicesPage